var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasAnItem ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [1 < _vm.keys.length ? _c('v-btn-toggle', {
    staticClass: "lang-toggle",
    model: {
      value: _vm.key,
      callback: function callback($$v) {
        _vm.key = $$v;
      },
      expression: "key"
    }
  }, [_vm._l(_vm.keys, function (value) {
    return [_c('v-btn', _vm._b({
      key: value
    }, 'v-btn', {
      value: value
    }, false), [_vm._v(" " + _vm._s(_vm.getKeyText(value)))])];
  })], 2) : _vm._e(), _c('v-expand-transition', [_c('v-responsive', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('youtube', _vm._b({
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fitParent": ""
    },
    on: {
      "ready": _vm.onReady
    }
  }, 'youtube', {
    videoId: _vm.videoId
  }, false))], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }